import http from "@/utils/request";
import axios from "axios";

// http 响应拦截器會引起屏幕閃爍
const http1 = axios.create({
    baseURL: "/api",
    // 设置区分开发与生产环境url
    //baseURL: process.env.NODE_ENV === "development" ? "/api" : baseURL,
    timeout: 50000,
});
http1.interceptors.request.use(function (config) {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    config.withCredentials = true; // 允许携带cookie
    return config;
}, function (error) {
    return Promise.reject(error);
});
http1.interceptors.response.use(
    response => {
        let res = response.data;
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        return res;
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    });

// 获取登录请求
export const UserLogin = (data) => {
    return http.post("/Setup_login/UserLogin", data);
};
// 獲取登錄QrCode圖片
export const GetQrCode = () => {
    return http.get("/RequstCommon/LoginQrCode");
};
// 掃碼登錄結果檢查
export const QrCodeLogin = (params) => {
    return http1.get("/ProanOrder/QrCodeLogin", params);
};
//修改密碼
export const ChangePassword = (data) => {
    return http.post("/Setup_login/ChangePassword", data);
};
